import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FCPState, GetOrganizationDto, OrganizationProvider } from '@modeso/aumico-lib-users-fe';
import Debug from 'debug';
import { Observable, filter, mergeMap, of } from 'rxjs';

const debug = Debug('aumico:AuthGuard');
@Injectable({
    providedIn: 'root',
})
export class FCPGuard implements CanActivate {
    constructor(private readonly organizationProvider: OrganizationProvider, private readonly router: Router) {}

    canActivate(): Observable<boolean | UrlTree> {
        const language = localStorage.getItem('currentLanguage');
        const financialOverviewUrl = this.router.parseUrl(`${language}/financial-overview`);

        this.organizationProvider.dispatchGetCurrentOrganization();

        return this.organizationProvider.getCurrentOrganization$().pipe(
            filter((organization: GetOrganizationDto) => organization != null),
            mergeMap((organization: GetOrganizationDto) => {
                const isFcpActive =
                    [FCPState.PAID, FCPState.TRIAL].includes(organization.fcpActivationDetails?.subscriptionState)
                if (isFcpActive) {
                    return of(true);
                } else {
                    return of(financialOverviewUrl);
                }
            }),
        );
    }
}
